import { render, staticRenderFns } from "./ModProject.vue?vue&type=template&id=4d4ca030&"
import script from "./ModProject.vue?vue&type=script&lang=js&"
export * from "./ModProject.vue?vue&type=script&lang=js&"
import style0 from "./ModProject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports